<div class="sc-text">
  <div *ngIf="scLabel">
    <label class="input-label" [innerHTML]="scLabel">
    </label>
    <span *ngIf="scLabel" class="sc-required sc-required-star"></span>
  </div>
  <input #scInput
         [attr.disabled]="isDisabled ? true : null"
         tabindex="scTabindex"
         [attr.type]="scType"
         [attr.placeholder]="scPlaceholder"
         [max]="scMax"
         [min]="scMin"
         [(ngModel)]="value"
         (focus)="onFocus($event)"
         (focusout)="onFocusOut($event)"
         (blur)="onBlur($event)"
         class="sabis-text"
         autocomplete="off"
         (ngModelChange)="onModelChange($event)"
         (keypress)="onKeyPress($event)" />
  <a href="javascript: void(0);" *ngIf="scShowClearButton && hasFocus && isClearBtnVisible" class="input-clear" tabindex="-1" (click)="onClearClick()">
    <mat-icon>close</mat-icon>
  </a>
</div>
<p class="sc-error-message" *ngIf="!scHideValidationMessage && !isValid">{{validationMessage}}</p>
